import { defineFetch } from 'resift';
import _get from 'lodash/get';

const makeImportAndValidateFile = defineFetch({
  displayName: 'Import And Validate Entity Source File',
  make: () => ({
    request: (entityTypeId: string, file: File, deleteEntities: boolean = false) => async ({
      http,
    }) => {
      const signUploadResponse = await http({
        method: 'GET',
        route: '/entity-source-files/sign-upload',
        query: {
          name: file.name,
          contentType: 'text/csv',
          size: file.size,
          entityTypeId,
        },
      });

      const key = _get(signUploadResponse, 'key');
      const url = _get(signUploadResponse, 'url');

      await fetch(url, {
        method: 'PUT',
        mode: 'cors',
        headers: {
          ..._get(signUploadResponse, 'fields'),
          Accept: `${_get(signUploadResponse, 'fields.Content-Type')}`,
        },
        body: file,
      });

      const createEntitySourceFileResponse = await http({
        method: 'POST',
        route: '/entity-source-files',
        data: {
          entityTypeId,
          key,
          size: file.size,
          contentType: 'text/csv',
          name: file.name,
          isActive: false,
          deleteEntities,
        },
      });

      const entitySourceFileId = _get(createEntitySourceFileResponse, 'id');

      const validationResponse = await http({
        method: 'GET',
        route: `/entity-source-files/${entitySourceFileId}/validation`,
      });

      const validationResults = _get(validationResponse, 'validationResults', []);

      return {
        validationResults,
        entitySourceFileId,
      };
    },
  }),
});

const importAndValidateFile = makeImportAndValidateFile();

export default importAndValidateFile;
